"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const viewPathMapping = {
    start: () => Promise.resolve().then(() => __importStar(require('../views/Start/Start'))),
    login: () => Promise.resolve().then(() => __importStar(require('../views/Auth/Login/Login'))),
    'login-step-2': () => Promise.resolve().then(() => __importStar(require('../views/Auth/Login/LoginStep2'))),
    'change-temporary-password': () => Promise.resolve().then(() => __importStar(require('../views/Auth/Login/ChangeTemporaryPassword'))),
    register: () => Promise.resolve().then(() => __importStar(require('../views/Auth/Register/Register'))),
    'reset-password': () => Promise.resolve().then(() => __importStar(require('../views/Auth/Register/Register'))),
    'logged-in-external': () => Promise.resolve().then(() => __importStar(require('../views/Auth/Login/LoggedInExternal'))),
    'logout-external': () => Promise.resolve().then(() => __importStar(require('../views/Auth/Login/LogoutExternal'))),
    'booking-link': () => Promise.resolve().then(() => __importStar(require('../views/Booking/Booking'))),
    booking: () => Promise.resolve().then(() => __importStar(require('../views/Booking/Booking'))),
    history: () => Promise.resolve().then(() => __importStar(require('../views/DonorHistory/DonorHistory'))),
    awards: () => Promise.resolve().then(() => __importStar(require('../views/Awards/Awards'))),
    settings: () => Promise.resolve().then(() => __importStar(require('../views/DonorContactInformation/DonorContactInformation'))),
    ehd: () => Promise.resolve().then(() => __importStar(require('../views/EHD/EHD'))),
    messages: () => Promise.resolve().then(() => __importStar(require('../views/Messages/Messages'))),
    'custom-page': () => Promise.resolve().then(() => __importStar(require('../views/Custom/Custom'))),
};
exports.default = viewPathMapping;
